(function ($) {
  $('.availability-btn').on('click', function () {
    const id = $(this).data('id');
    id === undefined ? $('.inventory-modal').show()  : $(`#${id}`).show();
  });

  $('.availability-btn').keypress(function(event) {
    if (event.keyCode === 13) {
      $('.availability-btn').click();
    }
  });

  $('.inventory-modal__close-button').on('click', function () {
    $('.inventory-modal').hide();
  });

  $('#location-select').change(function() {
    $('.location-option').css('display', 'none');
    $('#'+$(this).val()+'.location-option').css('display', 'block');
  });
})(jQuery);
